import script from "./departmentDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./departmentDetail.vue?vue&type=script&setup=true&lang=js"

import "./departmentDetail.vue?vue&type=style&index=0&id=55df1d8c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Acer\\Desktop\\mav\\surkhet\\patient-portal-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55df1d8c"]])

export default __exports__